/* Who we supply carousel — verbatim from adensalt.com section-scripts-b.js (the "Who we supply carousel" IIFE).
   Prev/next scroll #wc-track by one card + gap; aria-disabled tracks the scroll edges; nav is unhidden once JS runs. No endpoint or DOM changes. */
/* ---------- Who we supply carousel ---------- */
(function(){
  var root = document.getElementById('who-we-supply');
  if(!root) return;
  var track = root.querySelector('.wc-track');
  var nav = root.querySelector('.wc-nav');
  var prev = root.querySelector('.wc-btn-prev');
  var next = root.querySelector('.wc-btn-next');
  if(!track || !nav || !prev || !next) return;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced(){ return !!(mq && mq.matches); }
  function stepSize(){
    var card = track.querySelector('.wc-card');
    if(!card) return track.clientWidth;
    var cs = window.getComputedStyle(track);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function setState(btn, off){
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
  }
  function update(){
    var max = track.scrollWidth - track.clientWidth;
    var x = track.scrollLeft;
    setState(prev, x <= 2);
    setState(next, x >= max - 2);
  }
  var ticking = false;
  function onScroll(){
    if(ticking) return;
    ticking = true;
    window.requestAnimationFrame(function(){ ticking = false; update(); });
  }
  function go(dir){
    track.scrollBy({left: dir * stepSize(), behavior: reduced() ? 'auto' : 'smooth'});
  }
  prev.addEventListener('click', function(){ if(prev.getAttribute('aria-disabled') !== 'true') go(-1); });
  next.addEventListener('click', function(){ if(next.getAttribute('aria-disabled') !== 'true') go(1); });
  track.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  nav.hidden = false;
  update();
})();
